/**
 * The id of the chat message currently being rendered.
 *
 * A leaf (React-only) context, provided per message by the transcript and read
 * by deeply-nested markdown components (e.g. the table renderer) that need to
 * act on their own message — without importing chat models into the render
 * chain. Same decoupling rationale as {@link ChatTableActions}.
 */

import { createContext, useContext } from 'react';

const ChatMessageIdContext = createContext<string | null>(null);

export const ChatMessageIdProvider = ChatMessageIdContext.Provider;

export const useChatMessageId = (): string | null =>
  useContext(ChatMessageIdContext);
